document.documentElement.classList.remove('no-js');
const dialogOpeners = new WeakMap();
function openDialog(dialog, opener) {
  if (!dialog || typeof dialog.showModal !== 'function') return false;
  dialogOpeners.set(dialog, opener);
  if (!dialog.open) dialog.showModal();
  return true;
}
document.querySelectorAll('dialog').forEach(dialog => {
  dialog.addEventListener('close', () => dialogOpeners.get(dialog)?.focus());
});
let quickViewRequest;
document.addEventListener('click', async event => {
  const toggle = event.target.closest('[data-mobile-menu-toggle]');
  if (toggle) {
    const menu = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!menu) return;
    menu.hidden = !menu.hidden;
    toggle.setAttribute('aria-expanded', String(!menu.hidden));
    toggle.setAttribute('aria-label', menu.hidden ? 'Open menu' : 'Close menu');
  }
  const search = event.target.closest('[data-search-open]');
  if (search && openDialog(document.getElementById('SearchDialog'), search)) {
    event.preventDefault(); document.getElementById('HeaderSearch')?.focus();
  }
  const close = event.target.closest('[data-dialog-close]');
  if (close) close.closest('dialog')?.close();
  const thumb = event.target.closest('[data-gallery-thumb]');
  if (thumb) {
    const gallery = thumb.closest('[data-gallery]');
    const slide = [...gallery.querySelectorAll('[data-media-id]')].find(el => el.dataset.mediaId === thumb.dataset.galleryThumb);
    if (slide) { event.preventDefault(); gallery.querySelector('.gallery-slides').scrollLeft = slide.offsetLeft; }
  }
  const quick = event.target.closest('[data-quick-view]');
  if (!quick) return;
  const dialog = document.getElementById('QuickViewDialog');
  const content = dialog?.querySelector('[data-quick-view-content]');
  if (!content || !openDialog(dialog, quick)) return;
  quickViewRequest?.abort();
  quickViewRequest = new AbortController();
  content.textContent = 'Loading product…';
  try {
    const url = new URL(quick.dataset.quickView, location.origin);
    if (url.origin !== location.origin) throw new Error('Invalid product URL');
    url.searchParams.set('section_id', 'quick-view');
    const response = await fetch(url, { signal: quickViewRequest.signal });
    if (!response.ok) throw new Error('Product request failed');
    const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
    const result = parsed.querySelector('.quick-view');
    if (!result) throw new Error('Product unavailable');
    content.replaceChildren(result);
  } catch (error) {
    if (error.name === 'AbortError') return;
    content.textContent = 'Unable to load product details. Please open the product page.';
    const link = document.createElement('a'); link.href = quick.dataset.quickView; link.textContent = 'View product'; link.className = 'button button--dark'; content.append(link);
  }
});
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape' || document.querySelector('dialog[open]')) return;
  const menu = document.querySelector('[data-mobile-menu]:not([hidden])');
  if (menu) {
    menu.hidden = true;
    const trigger = document.querySelector('[data-mobile-menu-toggle]');
    trigger?.setAttribute('aria-expanded', 'false'); trigger?.focus();
  }
  document.querySelectorAll('.nav-disclosure[open]').forEach(details => { details.open = false; });
});
document.addEventListener('change', event => {
  if (!event.target.matches('[data-purchase] select[name="id"]')) return;
  const root = event.target.closest('[data-purchase]');
  const selected = event.target.selectedOptions[0];
  const available = selected.dataset.available === 'true';
  root.querySelectorAll('[data-variant-price], [data-sticky-price]').forEach(el => { el.textContent = selected.dataset.price; });
  root.querySelector('[data-variant-availability]').textContent = available ? 'Available to order' : 'Sold out';
  const sku = root.querySelector('[data-variant-sku]'); sku.hidden = !selected.dataset.sku; sku.textContent = 'SKU: ' + (selected.dataset.sku || '');
  root.querySelectorAll('[data-add-to-cart]').forEach(button => { button.disabled = !available; button.textContent = available ? 'Add to cart' : 'Sold out'; });
  const url = new URL(location.href); url.searchParams.set('variant', selected.value); history.replaceState({}, '', url);
  const gallery = root.closest('.product-main')?.querySelector('[data-gallery]');
  if (gallery && selected.dataset.mediaId) {
    const photo = [...gallery.querySelectorAll('[data-media-id]')].find(el => el.dataset.mediaId === selected.dataset.mediaId);
    if (photo) gallery.querySelector('.gallery-slides').scrollLeft = photo.offsetLeft;
  }
});
document.querySelectorAll('[data-gallery]').forEach(gallery => {
  const slides = [...gallery.querySelectorAll('.gallery-slide')];
  const scroller = gallery.querySelector('.gallery-slides');
  const thumbnails = [...gallery.querySelectorAll('[data-gallery-thumb]')];
  const counter = gallery.querySelector('[data-gallery-current]');
  if (!scroller || slides.length < 2) return;
  const show = index => {
    const nextIndex = Math.max(0, Math.min(slides.length - 1, index));
    scroller.scrollTo({left: slides[nextIndex].offsetLeft, behavior: 'smooth'});
    thumbnails.forEach((thumb, thumbIndex) => {
      const active = thumbIndex === nextIndex;
      thumb.classList.toggle('is-active', active);
      if (active) thumb.setAttribute('aria-current', 'true'); else thumb.removeAttribute('aria-current');
    });
    if (counter) counter.textContent = String(nextIndex + 1);
  };
  const currentIndex = () => Math.max(0, Math.min(slides.length - 1, Math.round(scroller.scrollLeft / Math.max(scroller.clientWidth, 1))));
  gallery.querySelector('[data-gallery-previous]')?.addEventListener('click', () => show(currentIndex() - 1));
  gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => show(currentIndex() + 1));
  let scrollTimer;
  scroller.addEventListener('scroll', () => {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(() => show(currentIndex()), 90);
  }, {passive: true});
});
document.querySelectorAll('[data-predictive-search]').forEach(form => {
  let timer, controller, generation = 0;
  const input = form.querySelector('input[name="q"]');
  const output = form.querySelector('#PredictiveResults');
  input.addEventListener('input', () => {
    clearTimeout(timer); controller?.abort();
    const current = ++generation;
    const query = input.value.trim();
    output.replaceChildren(); output.setAttribute('aria-busy', 'false');
    if (query.length < 2) return;
    timer = setTimeout(async () => {
      controller = new AbortController(); output.setAttribute('aria-busy', 'true');
      try {
        const url = new URL(form.dataset.endpoint, location.origin);
        url.search = new URLSearchParams({ q: query, 'resources[type]': 'product', 'resources[limit]': '6', section_id: 'predictive-search' });
        const response = await fetch(url, { signal: controller.signal });
        if (!response.ok) throw new Error('Search unavailable');
        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        const results = parsed.querySelector('.predictive-results');
        if (current !== generation) return;
        if (results) output.replaceChildren(results);
      } catch (error) {
        if (error.name !== 'AbortError' && current === generation) output.textContent = 'Press Search to see all results.';
      } finally { if (current === generation) output.setAttribute('aria-busy', 'false'); }
    }, 220);
  });
});

const compareInputs = [...document.querySelectorAll('[data-compare-product]')];
if (compareInputs.length) {
  const compareTray = document.createElement('aside');
  compareTray.className = 'compare-tray';
  compareTray.hidden = true;
  compareTray.setAttribute('aria-live', 'polite');
  compareTray.innerHTML = '<div><strong data-compare-count>0 cameras selected</strong><span data-compare-names></span></div><a class="button button--dark" href="#CompareCameras">Compare now</a>';
  document.body.append(compareTray);
  const selected = new Map();
  const renderCompareTray = () => {
    const products = [...selected.values()];
    compareTray.hidden = products.length === 0;
    compareTray.querySelector('[data-compare-count]').textContent = `${products.length} ${products.length === 1 ? 'item' : 'items'} selected`;
    compareTray.querySelector('[data-compare-names]').textContent = products.map(item => item.title).join(' · ');
  };
  compareInputs.forEach(input => input.addEventListener('change', () => {
    const key = `${input.dataset.brand}-${input.dataset.title}`;
    if (input.checked && selected.size >= 4) {
      input.checked = false;
      compareTray.hidden = false;
      compareTray.querySelector('[data-compare-count]').textContent = 'Choose up to 4 items';
      return;
    }
    if (input.checked) selected.set(key, {...input.dataset}); else selected.delete(key);
    renderCompareTray();
  }));
}

document.querySelectorAll('[data-hero-slider]').forEach(slider => {
  const slides = [...slider.querySelectorAll('[data-hero-slide]')];
  const dots = [...slider.querySelectorAll('[data-hero-dot]')];
  const previous = slider.querySelector('[data-hero-previous]');
  const next = slider.querySelector('[data-hero-next]');
  if (slides.length < 2) return;

  let activeIndex = 0;
  let rotation;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const autoplay = slider.dataset.autoplay !== 'false';
  const interval = Math.max(4000, Number(slider.dataset.interval) || 6500);
  const showSlide = index => {
    activeIndex = (index + slides.length) % slides.length;
    slides.forEach((slide, slideIndex) => {
      const active = slideIndex === activeIndex;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', String(!active));
    });
    dots.forEach((dot, dotIndex) => {
      const active = dotIndex === activeIndex;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-current', String(active));
    });
  };
  const stopRotation = () => clearInterval(rotation);
  const startRotation = () => {
    stopRotation();
    if (autoplay && !reducedMotion) rotation = setInterval(() => showSlide(activeIndex + 1), interval);
  };

  previous?.addEventListener('click', () => { showSlide(activeIndex - 1); startRotation(); });
  next?.addEventListener('click', () => { showSlide(activeIndex + 1); startRotation(); });
  dots.forEach(dot => dot.addEventListener('click', () => { showSlide(Number(dot.dataset.heroDot)); startRotation(); }));
  slider.addEventListener('mouseenter', stopRotation);
  slider.addEventListener('mouseleave', startRotation);
  slider.addEventListener('focusin', stopRotation);
  slider.addEventListener('focusout', event => { if (!slider.contains(event.relatedTarget)) startRotation(); });
  document.addEventListener('visibilitychange', () => document.hidden ? stopRotation() : startRotation());
  startRotation();
});
